import * as React from 'react';
import { Button } from '../button/Button';
import { Flex } from './FlexHelpers';


type CardPagerProps = {
    items: number,
    itemsPerPage: number,
    currentPage: number
    onPageChange: (newPage: number) => void
}
export const CardPager = ({ items, itemsPerPage, currentPage, onPageChange }: CardPagerProps): JSX.Element => {

    const handlePageButtonClick = (direction: 'up' | 'down') =>
        onPageChange(direction === 'up' ? currentPage + 1 : currentPage - 1);

    const pages = Math.ceil(items / itemsPerPage);

    const pageItems = [];
    for (let i = 1; i <= pages; i++)
        pageItems.push(i);

    return (
        <Flex flexDirection='row' justifyContent='center' alignItems='center'>
            <Button
                variant='text'
                disabled={currentPage <= 1} 
                onClick={() => handlePageButtonClick('down')}
                icon='arrows_chevron_chevronBack' 
            />

            <span>
                side {currentPage} af {pages}
            </span>

            <Button
                variant='text'
                disabled={currentPage >= pages} 
                onClick={() => handlePageButtonClick('up')}
                icon='arrows_chevron_chevronForward'
            />

        </Flex>
    );
} 